import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: JSON.parse(sessionStorage?.getItem("authUser")) || {},
  error: false,
  loading: false,
  isUserLogout: false,
  errorMsg: "",
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = true;
      state.isUserLogout = false;
      state.errorMsg = action.payload;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.error = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    loadingData(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { apiError, loginSuccess, logoutUserSuccess, loadingData } =
  loginSlice.actions;

export default loginSlice.reducer;
